import React, { memo } from 'react';
import styled from '@emotion/styled';
import { withTranslate } from '../../../../../shared/i18n/translate';
import { Column, ColumnHeader } from './Column';
import themed from '../../../../../../ui/themer/themed';

interface IProps {
	baggageBelt: string[];
	role?: 'columnheader' | 'cell';
}

export const StyledBaggageClaimColumn = styled(
	({ role = 'columnheader', ...props }) =>
		role === 'columnheader' ? (
			<ColumnHeader {...props} />
		) : (
			<Column {...props} />
		),
)`
	color: ${themed(({ color }) => color.text.default)};
	font-weight: 700;

	min-width: 130px;
	max-width: 170px;

	@media (max-width: 1200px) {
		display: none;
	}
`;

export const BaggageClaimColumn = memo(
	withTranslate<IProps>(({ baggageBelt, role }) => {
		const displayValue =
			baggageBelt && baggageBelt.length ? baggageBelt.join(', ') : undefined;

		return (
			<StyledBaggageClaimColumn role={role}>
				{displayValue}
			</StyledBaggageClaimColumn>
		);
	}),
);
